import { useIntl } from "react-intl";
import messages from "./messages.i18n";
import * as yup from "yup";
import { PeekAddressInput, PeekPhoneInput } from "@piiqtechnologies/ui-components";
import { CommunityFeaturesSelector } from "../community-features-selector";
import CommunityPlanSelector from "../community-plan-selector/CommunityPlanSelector";
import TimezoneSelector from "@components/common/form/timezone-selector";
import { OrganizationSearchSelector } from "@components/common/organization-search-selector";
export const CreateOrEditFormValidationSchema = () => {
    const intl = useIntl();
    return yup.object().shape({
        plan: yup.string().required(intl.formatMessage(messages.communityPlanRequired)),
        name: yup
            .string()
            .min(1, intl.formatMessage(messages.communityNameLength))
            .required(intl.formatMessage(messages.communityNameRequired)),
        communityContact: yup.object().shape({
            contactPhone: yup.string().matches(/\d{3}-\d{3}-\d{4}/, intl.formatMessage(messages.communityNumberFormat)),
        }),
        leadsEmail: yup
            .string()
            .email(intl.formatMessage(messages.communityEmailInvalid))
            .required(intl.formatMessage(messages.communityLeadsEmailRequired)),
        address: yup.object({ name: yup.string() }).test({
            message: intl.formatMessage(messages.communityBuildingsRequired),
            test: (value) => value && value.name && value.name.length > 0,
        }),
        timezone: yup.string().required(intl.formatMessage(messages.communityTimeZoneRequired)),
    });
};
export const CreateOrEditCommunityFormFields = (communityId) => {
    const intl = useIntl();
    return {
        communityInfo_column1: {
            communityInfo: {
                communityInfo: [
                    {
                        id: "name",
                        label: intl.formatMessage(messages.communityName),
                        placeholder: intl.formatMessage(messages.communityName),
                        required: true,
                        columns: 12,
                    },
                    {
                        id: "leadsEmail",
                        label: intl.formatMessage(messages.communityLeadsEmail),
                        placeholder: intl.formatMessage(messages.communityLeadsEmail),
                        required: true,
                        columns: 6,
                    },
                    {
                        id: "communityContact.contactPhone",
                        label: intl.formatMessage(messages.communityPhone),
                        placeholder: "XXX-XXX-XXXX",
                        required: false,
                        columns: 6,
                        component: PeekPhoneInput,
                    },
                ],
            },
        },
        communitySpacesInfo_column2: {
            communitySpacesInfo: {
                communitySpacesInfo: [
                    {
                        id: "organization",
                        label: intl.formatMessage(messages.communityOrganization),
                        placeholder: intl.formatMessage(messages.communityOrganization),
                        required: true,
                        component: OrganizationSearchSelector,
                        columns: 5,
                    },
                    {
                        id: "metroArea",
                        label: intl.formatMessage(messages.communityMetro),
                        placeholder: intl.formatMessage(messages.communityMetro),
                        required: false,
                        columns: 7,
                    },
                    {
                        id: "address",
                        label: intl.formatMessage(messages.communityBuildings),
                        placeholder: intl.formatMessage(messages.communityBuildings),
                        required: true,
                        component: PeekAddressInput,
                        columns: 12,
                    },
                    {
                        id: "timezone",
                        label: intl.formatMessage(messages.communityTimeZone),
                        placeholder: intl.formatMessage(messages.communityTimeZone),
                        required: true,
                        fullWidth: true,
                        component: TimezoneSelector,
                        columns: 5,
                    },
                ],
            },
        },
        communityPlanInfo_column3: {
            communityPlanInfo: {
                communityPlanInfo: [
                    {
                        id: "plan",
                        label: intl.formatMessage(messages.communityPlan),
                        placeholder: intl.formatMessage(messages.communityPlan),
                        component: CommunityPlanSelector,
                        required: true,
                        columns: 12,
                    },
                    {
                        id: "features",
                        label: "features",
                        placeholder: "features",
                        component: CommunityFeaturesSelector,
                        required: true,
                        columns: 12,
                    },
                ],
            },
        },
    };
};
